<template>
  <v-app>
    <div class="hidden-sm-and-down">
      <v-app-bar
        app
        color="white"
        height="100"
      >
        <div style="margin-left:-10px">
          <v-img
            contain
            max-height="100px"
            src="./assets/cs_logo.png"
            @click="$vuetify.goTo('#hero')"
          ></v-img>
        </div>
        <v-toolbar-title
          class="font-weight-black headline"
          style="padding-left:20px"
        >
          <div style="
          position: absolute;
          right: 15%;
          bottom: 0">
            <v-btn
              text
              large
              color="black"
              height="100"
              @click="$vuetify.goTo('#about-us')"
            >ABOUT US</v-btn>
            <v-btn
              text
              large
              color="black"
              height="100"
              @click="$vuetify.goTo('#services')"
            >SERVICES</v-btn>
            <v-btn
              text
              large
              color="black"
              height="100"
              @click="$vuetify.goTo('#contact')"
            >CONTACT US</v-btn>
          </div>
        </v-toolbar-title>
      </v-app-bar>
    </div>
    <div class="hidden-md-and-up">

      <v-app-bar
        app
        color="white"
        height="100"
      >
        <v-toolbar
          flat
          color="white"
          height="100"
        >
          <v-app-bar-nav-icon
            @click="drawer = !drawer"
            color="black"
            class="hidden-md-and-up"
          ></v-app-bar-nav-icon>

          <v-img
            contain
            max-height="100px"
            src="./assets/cs_logo.png"
            @click="$vuetify.goTo('#hero')"
          ></v-img>

        </v-toolbar>
        <v-navigation-drawer
          v-model="drawer"
          dark
          color="white  "
          absolute
          temporary
          width="200px"
          height="100vH"
        >
          <v-list
            nav
            dense
          >
            <v-list-item-group
              style="text-align:left"
              active-class="deep-grey--text text--accent-4"
            >
              <v-app-bar-nav-icon
                style="margin-top:-5px"
                @click="drawer = !drawer"
                color="black"
              ></v-app-bar-nav-icon>
              <br>
              <v-btn
                text
                color="black"
                v-on:click.prevent="closeNav()"
                @click="$vuetify.goTo('#hero')"
              >HOME</v-btn>
              <v-btn
                text
                color="black"
                v-on:click.prevent="closeNav()"
                @click="$vuetify.goTo('#about-us')"
              >ABOUT US</v-btn>
              <v-btn
                text
                color="black"
                v-on:click.prevent="closeNav()"
                @click="$vuetify.goTo('#services')"
              >SERVICES</v-btn>
              <v-btn
                text
                color="black"
                v-on:click.prevent="closeNav()"
                @click="$vuetify.goTo('#contact')"
              >CONTACT US</v-btn>

            </v-list-item-group>
          </v-list>
        </v-navigation-drawer>
      </v-app-bar>
    </div>
    <v-content>
      <section id="hero">
        <v-row no-gutters>

          <v-img
            :min-height="'calc(100vh - ' + $vuetify.application.top + 'px)'"
            
            src="./assets/home.jpg"
          >

            <v-card
              :min-height="'calc(100vh - ' + $vuetify.application.top + 'px)'"
              height='100%'
              color="rgb(0, 0, 0, 0.6)"
              align="center"
              justify="center"
            >
              <br><br><br>
              <v-container>
                <v-img
                  contain
                  max-height="150px"
                  src="./assets/cs_logo.png"
                  style="margin-bottom:50px"
                ></v-img>
                <v-row
                  align="center"
                  class="black--text mx-auto"
                  justify="center"
                >
                  <v-col
                    class="white--text text-center"
                    cols="12"
                    tag="h1"
                  >
                    <span
                      :class="[$vuetify.breakpoint.smAndDown ? 'display-1': 'display-1']"
                      class="font-weight-light"
                    >
                      CS MUTIARA SDN. BHD. (1237289-H)
                    </span>
                    <span
                      class="font-weight-black"
                      :class="[$vuetify.breakpoint.smAndDown ? 'display-1' : 'display-2']"
                    >

                      <br><br><br><br><br><br><br><br>
                      <h3>YOUR BEST TRANSPORT SOLUTION</h3>
                    </span>

                    <br>

                  </v-col>
                </v-row>
                <br><br><br><br><br><br><br>
                <v-btn
                  class="align-self-end"
                  fab
                  outlined
                  color="white"
                  @click="$vuetify.goTo('#about-us')"
                >
                  <v-icon>mdi-chevron-double-down</v-icon>
                </v-btn>

              </v-container>
            </v-card>
          </v-img>

        </v-row>
      </section>

      <section id="about-us">
        <div class="py-6"></div>

        <v-container class="text-center">
          <h2 class="display-2 font-weight-bold mb-3">ABOUT US</h2>
          <v-row>
            <v-col>
              <v-img
                contain
                src="./assets/lorry.png"
              ></v-img>
            </v-col>
            <v-col>
              <v-responsive
                class="mx-auto title font-weight-light mb-8"
                max-width="720"
                style="text-align:justify;font-weight: 500;"
              >
                CS Mutiara Sdn Bhd is a transportation services provider in Malaysia having established in 2013 and based in Sekinchan, Selangor.
                The company offer excellent delivery and monitoring services to all the customers which will facilitate the entire delivery
                or collection process without any delay.
                The portfolio of products that CS Mutiara usually handle can be categorized into food and beverage, industrial material supply,
                construction materials and agricultural products.
              </v-responsive>
            </v-col>
          </v-row>

          <v-btn
            class="align-self-end"
            fab
            outlined
            @click="$vuetify.goTo('#services')"
          >
            <v-icon>mdi-chevron-double-down</v-icon>
          </v-btn>

        </v-container>

        <div class="py-6"></div>
      </section>

      <section
        id="services"
        class="grey lighten-3"
      >

        <v-img
          :min-height="'calc(100vh - ' + $vuetify.application.top + 'px)'"
          src="./assets/many_lorry.jpg"
        >
          <v-container class="text-center">
            <h2 class="display-2 font-weight-bold mb-3">SERVICES</h2>
            <v-responsive
              class="mx-auto font-weight-light mb-8 service"
              max-width="720"
              style="text-align:justify;"
            >
              Transportation is one of the important processes in the supply chain.
              This services enables us to support customer requirement and efficiency attended.
              Here we offer excellent delivery and monitoring services to all the customers,
              which will facilitate the entire delivery or collection process without any delay.
              Delivery Route: To all states except Kelantan &amp; Pahang (vice versa)

            </v-responsive>
          </v-container>
          <div
            class="display-2 font-weight-bold mb-3"
            align="center"
            style="margin-top:50px"
          >
            <v-btn
              fab
              class="text-center"
              @click="$vuetify.goTo('#contact')"
            >
              <v-icon>mdi-chevron-double-down</v-icon>
            </v-btn>
          </div>

        </v-img>
      </section>

      <v-sheet
        id="contact"
        color="#333333"
        dark
        tag="section"
        tile
      >
        <div class="py-6"></div>
        <v-container>
          <h2 class="display-1 font-weight-bold mb-3 text-center">CONTACT US</h2>

          <v-theme-provider light>
            <form
              action="https://formsubmit.co/cherrykok0926@gmail.com"
              method="POST"
            >
              <v-row>
                <v-col cols="4">
                  <v-text-field
                    flat
                    label="Name*"
                    name="name"
                    solo
                    class="form-control"
                  ></v-text-field>
                </v-col>

                <v-col cols="4">
                  <v-text-field
                    flat
                    label="Email*"
                    type="email"
                    name="email"
                    solo
                    class="form-control"
                  ></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    flat
                    label="Phone*"
                    name="phone"
                    solo
                    class="form-control"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    flat
                    label="Message*"
                    name="message"
                    solo
                    class="form-control"
                  ></v-textarea>
                </v-col>

                <v-col
                  class="mx-auto"
                  cols="auto"
                >
                  <v-btn
                    color="primary"
                    x-large
                    type="submit"
                  >
                    SEND FORM
                  </v-btn>
                </v-col>
              </v-row>
            </form>
          </v-theme-provider>
        </v-container>

        <div class="py-6"></div>
      </v-sheet>
    </v-content>

    <v-footer
      class="justify-center"
      color="#292929"
    >

      <v-row>
        <v-col cols=12>
          <v-container
            class="title font-weight-light grey--text text--lighten-1"
            style="margin-bottm:10%"
          >
            <v-row>
              <v-col cols=2>
                <v-icon color="white">mdi-home</v-icon>
              </v-col>
              <v-col>
                Lorong 6, Site C, 45400 Sekinchan, Selangor Darul Ehsan.
              </v-col>
            </v-row>
            <v-row>
              <v-col cols=2>
                <v-icon color="white">mdi-email</v-icon>
              </v-col>
              <v-col>
                csmutiara@live.com
              </v-col>
            </v-row>
            <v-row>
              <v-col cols=2>
                <v-icon color="white"> mdi-phone</v-icon>
              </v-col>
              <v-col>
                016-966 7666
              </v-col>
            </v-row>
          </v-container>
        </v-col>

        <v-col>
          <div class="title font-weight-light grey--text text--lighten-1 text-center">
            Copyright &copy; {{ (new Date()).getFullYear() }} CS Mutiara . All rights reserved.
          </div>
        </v-col>
      </v-row>
    </v-footer>
  </v-app>
</template>
 <script>
export default {
  data() {
    return {
      name: null,
      email: null,
      subject: null,
      message: null,
      drawer: false
    };
  },
  methods: {
    closeNav() {
      this.drawer = false;
    },
    submit() {
      console.log(this.name, this.email, this.subject, this.message);
    }
  }
};
</script>

<style>
.img {
  background: rgba(255, 0, 0, 0.3);
}

.service {
  font-size: calc(14px + (26 - 14) * ((100vw - 300px) / (1600 - 300)));
}

</style>